"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCustomBoolEventObserver = void 0;
var _react = require("react");
const useCustomBoolEventObserver = eventKey => {
  const [value, setValue] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    const listener = event => {
      var _event$detail;
      setValue(event === null || event === void 0 || (_event$detail = event.detail) === null || _event$detail === void 0 ? void 0 : _event$detail.value);
    };
    window.addEventListener(eventKey, listener);
    return () => window.removeEventListener(eventKey, listener);
  }, [eventKey]);
  return [value, setValue];
};
exports.useCustomBoolEventObserver = useCustomBoolEventObserver;